const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export function isReducedMotion() {
  return reducedMotion.matches;
}
